/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Check_ReadmeInputs */

const en_rd_check_readme = /** @type {(inputs: Rd_Check_ReadmeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`README with setup commands`)
};

const id_rd_check_readme = /** @type {(inputs: Rd_Check_ReadmeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`README berisi perintah setup`)
};

/**
* | output |
* | --- |
* | "README with setup commands" |
*
* @param {Rd_Check_ReadmeInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_check_readme = /** @type {((inputs?: Rd_Check_ReadmeInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Check_ReadmeInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_check_readme(inputs)
	return en_rd_check_readme(inputs)
});